import { MINIMUM_CHAT_WINDOW_HEIGHT } from 'constants/ScreenDimensions';

const LOW_BANDWIDTH_ERR_VERTICAL_OFFSET = 40;
const STAGE_PADDING = 8;
const HEADER_HEIGHT = 55;
const CHAT_MARGIN = 16;
const CONTROL_PANEL_HEIGHT = 65;

function getChatHeight(pageHeight, stageHeight, mediaElementHeight) {
  let newHeight =
    pageHeight -
    HEADER_HEIGHT -
    stageHeight -
    STAGE_PADDING -
    CHAT_MARGIN -
    CONTROL_PANEL_HEIGHT -
    LOW_BANDWIDTH_ERR_VERTICAL_OFFSET -
    mediaElementHeight;

  return newHeight > MINIMUM_CHAT_WINDOW_HEIGHT
    ? newHeight
    : MINIMUM_CHAT_WINDOW_HEIGHT;
}

export default getChatHeight;
